import { Message } from "primereact/message";
import { Column } from "primereact/column";
import { protocolsApi } from "../../services/protocols/protocolsApi";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "../../components/data/DataTable";
import { Button } from "primereact/button";
import Error from "../../components/common/Error";
import { Link } from "react-router-dom";
import { Tag } from "primereact/tag";

interface TeacherProtocolsProps {
  teacherId?: number;
}

const TeacherProtocols = ({ teacherId }: TeacherProtocolsProps) => {
  if (!teacherId) {
    return (
      <Message severity="info" text="Моля, първо запазете основните данни на преподавателя." className="w-full my-4" />
    );
  }

  const { data: protocols, error, isLoading } = protocolsApi.useGetTeacherProtocolsQuery(teacherId);

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <div className="card mt-4">
      <h2>Протоколи на преподавател</h2>
      <DataTable
        value={protocols?.data ?? []}
        emptyMessage="Не бяха открити протоколи."
        stateStorage="session"
        stateKey="dt-teacher-protocols-list"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        className="p-datatable-sm"
      >
        <Column field="protocolNumber" header="Номер" sortable filter></Column>
        <Column field="subjectName" header="Дисциплина" sortable filter></Column>
        <Column field="specialityName" header="Специалност" sortable filter></Column>
        <Column field="semester" header="Семестър" sortable filter></Column>
        <Column field="issueDate" header="Дата на издаване" sortable filter></Column>
        <Column field="examDate" header="Дата на изпит" sortable filter></Column>
        <Column field="examTypeName" header="Тип изпит" sortable filter></Column>
        <Column field="semesterTypeName" header="Тип семестър" sortable filter></Column>
        <Column field="academicYearName" header="Учебна година" sortable filter></Column>
        <Column
          field="currentStatus"
          header="Статус"
          sortable
          filter
          body={(rowData) => (
            <Tag value={rowData.currentStatus} severity={rowData.currentStatus === "SIGNED" ? "success" : "info"} />
          )}
        />
        <Column
          body={(rowData) => (
            <Link to={`/protocols/${rowData.protocolId}`}>
              <Button icon="pi pi-eye" className="p-button-info" />
            </Link>
          )}
        />
      </DataTable>
    </div>
  );
};

export default TeacherProtocols;
